import React, { useState } from "react";

const SettingsIconLeftPanel = ({ isActive, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Colors based on state
  let backgroundColor = "transparent";
  let fillColor = "#969BA9";

  if (isHovered && !isActive) {
    backgroundColor = "#F6F6F6";
    fillColor = "var(--color-primary)";
  }

  if (isActive) {
    backgroundColor = "var(--color-primary)";
    fillColor = "#FFFFFF";
  }

  return (
    <span
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        width: "26px",
        height: "26px",
        borderRadius: "50%",
        // transition: "all 0.2s ease",
        backgroundColor,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transition: "fill 0.2s ease" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6 7C19.0971 7 19.5 7.39797 19.5 7.88889V8.77778H23.1C23.5971 8.77778 24 9.17575 24 9.66667C24 10.1576 23.5971 10.5556 23.1 10.5556H19.5V11.4444C19.5 11.9354 19.0971 12.3333 18.6 12.3333C18.1029 12.3333 17.7 11.9354 17.7 11.4444V7.88889C17.7 7.39797 18.1029 7 18.6 7ZM6 9.66667C6 9.17575 6.40295 8.77778 6.9 8.77778H15C15.4971 8.77778 15.9 9.17575 15.9 9.66667C15.9 10.1576 15.4971 10.5556 15 10.5556H6.9C6.40295 10.5556 6 10.1576 6 9.66667ZM11.4 12.3333C11.8971 12.3333 12.3 12.7313 12.3 13.2222V16.7778C12.3 17.2687 11.8971 17.6667 11.4 17.6667C10.9029 17.6667 10.5 17.2687 10.5 16.7778V15.8889H6.9C6.40295 15.8889 6 15.4909 6 15C6 14.5091 6.40295 14.1111 6.9 14.1111H10.5V13.2222C10.5 12.7313 10.9029 12.3333 11.4 12.3333ZM14.1 15C14.1 14.5091 14.5029 14.1111 15 14.1111H23.1C23.5971 14.1111 24 14.5091 24 15C24 15.4909 23.5971 15.8889 23.1 15.8889H15C14.5029 15.8889 14.1 15.4909 14.1 15ZM18.6 17.6667C19.0971 17.6667 19.5 18.0646 19.5 18.5556V19.4444H23.1C23.5971 19.4444 24 19.8424 24 20.3333C24 20.8243 23.5971 21.2222 23.1 21.2222H19.5V22.1111C19.5 22.602 19.0971 23 18.6 23C18.1029 23 17.7 22.602 17.7 22.1111V18.5556C17.7 18.0646 18.1029 17.6667 18.6 17.6667ZM6 20.3333C6 19.8424 6.40295 19.4444 6.9 19.4444H15C15.4971 19.4444 15.9 19.8424 15.9 20.3333C15.9 20.8243 15.4971 21.2222 15 21.2222H6.9C6.40295 21.2222 6 20.8243 6 20.3333Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default SettingsIconLeftPanel;
